import { message } from "antd";
import { IPageAddCallback, api } from "./index";
import { openModalTextBox } from "../components/ModalTextBox";
import { PageType } from "../const";
import { lang } from "../context";
import events from "../context/events";
import { ActionFnEnum, ActionType } from "../types";

const rename: IPageAddCallback = (props, isAllow) => {
  const { data, setData } = props;
  if (data.page_type !== PageType.File) {
    return;
  }
  return [
    {
      children: lang("ctx.rename.title"),
      callbackOrModal: () => {
        openModalTextBox({
          title: lang("ctx.rename.title"),
          value: data.title,
          maxLength: 50,
          onOk: (value, close) => {
            if (value.length > 50) {
              message.error("文件名称不能超过50个字符");
              return;
            }
            api.page.rename(data.id, value).then((res) => {
              console.log(res, "resresresres===>");
              // if (!res) {
              //   message.error("操作失败");
              //   return;
              // }
              // if (res.code === "10002") {
              //   message.error("文件后缀名有误，请确认后重试");
              //   return;
              // }
              if (!res?.data) {
                message.error(res.status);
                return;
              }
              if (res?.data) {
                const newData: any = {
                  ...props.data,
                  title: value
                };
                setData({
                  type: ActionFnEnum.UPDATE,
                  newItem: newData,
                  id: data.id,
                  actionType: ActionType.Page
                } as any);
                events.emit("list.check");
                message.success(lang("common.success"));
              } else {
                message.error(lang("common.suffix-error"));
              }
              close();
            });
          }
        });
      },
      isAllow,
      type: "rename",
      icon: "pc_yundoc_rename",
      splitCode: 1
    }
  ];
};

export default rename;
